import {
  Table,
  Thead,
  Th,
  Td,
  Tr,
} from '@lightspeed/cirrus-table';
import { Bone } from '@lightspeed/flame/Bone';
import { TableWithHeading } from './TableWithHeading';
import { IconCheckmark } from '@lightspeed/flame/Icon/Checkmark';
import { useTranslation } from 'react-i18next';
import useCurrency from '../../hooks/useCurrency';

const TaxCell = ({ value }) => {
  return <>
    {
      value === true &&
      <IconCheckmark />
    }
  </>;
};

const TableContent = ({ data, postingType }) => {
  const { t } = useTranslation();
  const { toCurrency } = useCurrency();

  return <Table>
    <Thead>
      <Tr>
        <Th>Name</Th>
        <Th>{t('Amount')}</Th>
        <Th>{t('Class')}</Th>
        <Th>{t('Unit price')}</Th>
        <Th>{t('Quantity')}</Th>
        <Th>{t('Tax')}</Th>
        {postingType === 1 && <>
          <Th>Income Account</Th>
          <Th>Expense Account</Th>
        </>}
        <Th>Asset Account</Th>
      </Tr>
    </Thead>
    <tbody>
      {
        data ?
          <>
            {data.length === 0 ?
              <Tr>
                <td colSpan="2">{t('No rows to show')}</td>
              </Tr> :
              data.map((item, index) => (
                <Tr key={index}>
                  <Td>{item.name}</Td>
                  <Td style={{ whiteSpace: 'pre' }}>{toCurrency(item.amount)}</Td>
                  <Td>{item.class}</Td>
                  <Td style={{ whiteSpace: 'pre' }}>{toCurrency(item.unitPrice)}</Td>
                  <Td>{item.quantity}</Td>
                  <Td><TaxCell value={item.taxEnabled} /></Td>
                  {postingType === 1 &&
                    <>
                      <Td>{item.incomeAccount}</Td>
                      <Td>{item.expenseAccount}</Td>
                    </>}
                  <Td>{item.assetAccount}</Td>
                </Tr>
              ))
            }
          </> :
          [1, 2, 3, 4, 5].map((item, index) => (
            <Tr key={index}>
              <Td><Bone height="1rem" /></Td>
              <Td><Bone height="1rem" /></Td>
              <Td><Bone height="1rem" /></Td>
              <Td><Bone height="1rem" /></Td>
              <Td><Bone height="1rem" /></Td>
              <Td><Bone height="1rem" /></Td>
              <Td><Bone height="1rem" /></Td>
              {postingType === 1 &&
                <>
                  <Td><Bone height="1rem" /></Td>
                  <Td><Bone height="1rem" /></Td>
                </>
              }
            </Tr>
          ))
      }
    </tbody>
  </Table>;
};

export const PurchasesTable = ({ heading, ...props }) => {
  const { data } = props;
  const canShowTable = data ? data.length > 0 : true;
  return <>
    {canShowTable &&
      <TableWithHeading heading={heading ?? 'Purchases'}>
        <TableContent {...props} />
      </TableWithHeading>
    }
  </>;
};
